import React from 'react';

import Thumb from '../img/hot-gadgets.png';
import Img from '../img/hot-gadgets2.png';

const HotGadgets = {
    id: 54, permalink: "hot-gadgets", thumb: Thumb, title: "Hot Gadgets", category: "Web Template", categoryURL: "webtemplate", detailImg1: Thumb, detailImg2: Img, previewTxt: "Preview", previewURL: "https://wasek23.github.io/hot-gadgets/", sourceTxt: "", sourceURL: "", description: <>
        <h3>Hot Gadgets is a Bootstrap eCommerce Web Template.</h3>
        <p>&nbsp;</p>

        <h5>Main Featured:</h5>
        <ul>
            <li>Fully Responsive Web Template.</li>
            <li>Menu Bookmark.</li>
            <li>Infinity Shadow Blinking in Button.</li>
            <li>Bootstrap Carousel.</li>
            <li>Bootstrap Cards.</li>
        </ul>

        <h5>Technology Used:</h5>
        <ul>
            <li>HTML5, CSS3, Bootstrap, JavaScript.</li>
        </ul>
    </>
};

export default HotGadgets;